import { render, staticRenderFns } from "./cargosConferenceObsDialog.vue?vue&type=template&id=dc5da2d0&scoped=true&"
import script from "./cargosConferenceObsDialog.vue?vue&type=script&lang=js&"
export * from "./cargosConferenceObsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5da2d0",
  null
  
)

export default component.exports